export const PAYMENT_SETUP_ATTEMPT_STATUSES = [
    "creating",
    "requiresAction",
    "processing",
    "ready",
    "failed",
    "expired",
    "superseded"
];
const ALLOWED_TRANSITIONS = {
    creating: ["requiresAction", "processing", "failed", "expired", "superseded"],
    requiresAction: ["processing", "ready", "failed", "expired", "superseded"],
    processing: ["requiresAction", "ready", "failed", "expired", "superseded"],
    ready: [],
    failed: ["processing", "ready", "superseded"],
    expired: ["processing", "ready", "superseded"],
    superseded: []
};
function record(value, field) {
    if (!value || typeof value !== "object" || Array.isArray(value))
        throw new Error(`${field} must be an object`);
    return value;
}
function exactKeys(value, keys, field) {
    const allowed = new Set(keys);
    const unknown = Object.keys(value).filter((key) => !allowed.has(key));
    if (unknown.length)
        throw new Error(`${field} contains unknown fields: ${unknown.join(", ")}`);
    const missing = keys.filter((key) => !(key in value));
    if (missing.length)
        throw new Error(`${field} is missing fields: ${missing.join(", ")}`);
}
export function parsePaymentSetupAttemptStatus(value) {
    if (typeof value !== "string" || !PAYMENT_SETUP_ATTEMPT_STATUSES.includes(value)) {
        throw new Error("paymentSetupAttempt.status is invalid");
    }
    return value;
}
export function canTransitionPaymentSetupAttempt(from, to) {
    return from === to || ALLOWED_TRANSITIONS[from].includes(to);
}
export function assertPaymentSetupAttemptTransition(from, to) {
    if (!canTransitionPaymentSetupAttempt(from, to)) {
        throw new Error(`paymentSetupAttempt transition ${from} -> ${to} is not allowed`);
    }
}
export function parseSafePaymentCard(value) {
    const card = record(value, "paymentSetup.card");
    exactKeys(card, ["brand", "last4", "expiryMonth", "expiryYear", "updatedAt"], "paymentSetup.card");
    if (typeof card.brand !== "string" || card.brand.length < 1 || card.brand.length > 32 || !/^[A-Za-z0-9 _-]+$/u.test(card.brand)) {
        throw new Error("paymentSetup.card.brand is invalid");
    }
    if (typeof card.last4 !== "string" || !/^\d{4}$/u.test(card.last4))
        throw new Error("paymentSetup.card.last4 is invalid");
    if (!Number.isInteger(card.expiryMonth) || card.expiryMonth < 1 || card.expiryMonth > 12) {
        throw new Error("paymentSetup.card.expiryMonth is invalid");
    }
    if (!Number.isInteger(card.expiryYear) || card.expiryYear < 2000 || card.expiryYear > 9999) {
        throw new Error("paymentSetup.card.expiryYear is invalid");
    }
    if (typeof card.updatedAt !== "string" || Number.isNaN(Date.parse(card.updatedAt)))
        throw new Error("paymentSetup.card.updatedAt is invalid");
    return card;
}
export function validatePaymentSetupMutationRequest(value) {
    const request = record(value, "paymentSetupRequest");
    exactKeys(request, ["expectedVersion"], "paymentSetupRequest");
    if (!Number.isInteger(request.expectedVersion) || request.expectedVersion < 1) {
        throw new Error("paymentSetupRequest.expectedVersion is invalid");
    }
    return { expectedVersion: request.expectedVersion };
}
export function assertPaymentSetupApplicationEligibility(input) {
    if (["activated", "rejected", "expired", "cancelled"].includes(input.lifecycleStatus) || input.lifecycleStatus === "provisioning") {
        throw new Error("APPLICATION_TERMINAL");
    }
    if (input.hasProvisioningLease)
        throw new Error("APPLICATION_PROVISIONING_IN_PROGRESS");
    if (input.stepStates.profile !== "complete")
        throw new Error("APPLICATION_STEP_INCOMPLETE");
    if (input.stepStates.emailVerification !== "verified")
        throw new Error("APPLICATION_EMAIL_NOT_VERIFIED");
    if (input.stepStates.identityLink !== "linked")
        throw new Error("APPLICATION_IDENTITY_NOT_LINKED");
    if (input.stepStates.pricingSelection !== "selected")
        throw new Error("APPLICATION_PRICING_NOT_SELECTED");
    if (input.stepStates.consent !== "acceptedCurrent")
        throw new Error("APPLICATION_CONSENT_REQUIRED");
}
